import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  propertyVerification: [],
  allPropertyVerification: [],
  allPropertyVerificationCount: [],
  allVerificationTag: []
};

export const PropertyVerificationsSlice = createSlice({
  name: "propertyVerifications",
  initialState,
  reducers: {
    getPropertyVerificationsAction: (state, action) => {
      state.allPropertyVerification = action.payload;
    },
    getPropertyVerificationsCountAction: (state, action) => {
      state.allPropertyVerificationCount = action.payload;
    },
    getPropertyVerificationAction: (state, action) => {
      state.propertyVerification = action.payload;
    },
    getVerificationTag: (state, action) => {
      state.allVerificationTag = action.payload;
    },
  },
});

export default PropertyVerificationsSlice.reducer;

export const { getPropertyVerificationsAction, getPropertyVerificationsCountAction, getPropertyVerificationAction, getVerificationTag } = PropertyVerificationsSlice.actions;
